import React, { ReactNode } from 'react';

import { styled } from '@mui/material/styles';

import Dialog from '@mui/material/Dialog';
import MuiDialogTitle from '@mui/material/DialogTitle';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogActions from '@mui/material/DialogActions';
import { IoMdCreate } from 'react-icons/io';
import { Button, IconWrapper } from '..';
import { Typography } from '../../Typography';

export interface Props {
  title: string;
  buttonText: string;
  buttonVariant?: 'outlined' | 'contained' | 'link';
  children?: ReactNode;
}
export interface DialogTitleProps {
  id: string;
  children: React.ReactNode;
  onClose: () => void;
}

const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  backgroundColor: '#F2F2F2',
  alignItems: 'center',
  display: 'flex',
  color: theme.palette.primary.main,
}));

const DialogTitle = (props: DialogTitleProps) => {
  const { children, ...other } = props;
  return (
    <StyledDialogTitle {...other}>
      <IconWrapper size="28px" backgroundColor="#FFF" rounded primaryColor primaryBorder icon={<IoMdCreate />} />
      <Typography margin="0 0 0 15px" display="inline-block" variant="title" primary>{children}</Typography>
    </StyledDialogTitle>
  );
};

const DialogContent = styled(MuiDialogContent)(({ theme }) => ({
  padding: theme.spacing(2),
}));

const DialogActions = styled(MuiDialogActions)(({ theme }) => ({
  background: theme.palette.primary.main,
  margin: 0,
  justifyContent: 'space-between',
  padding: '10px 20px',
}));

const ModalWrapper: React.FC<Props> = ({
  title,
  buttonText,
  buttonVariant = 'contained',
  children,
  ...props
}: Props) => {
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  return (
    <div>
      <Button color="primary" variant={buttonVariant} onClick={handleClickOpen}>
        {buttonText}
      </Button>
      <Dialog fullWidth maxWidth="lg" open={open}>
        <DialogTitle id="modal-title" onClose={handleClose}>
          {title}
        </DialogTitle>
        <DialogContent dividers>
          {children}
        </DialogContent>
        <DialogActions>
          <Button variant="link" onClick={handleClose}>
            Cancelar
          </Button>
          <Button variant="outlined">
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};


export { ModalWrapper as Modal };
